import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchAddOffersInFolders } from '../repositories/favorites/v1/add-offers-in-folders';
import { mapDealType, mapOfferType } from '../mappers';
export var addOffersToFolders = function addOffersToFolders(offerIds, folderIds, dealType, offerType) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
      var httpApi, logger, parameters, _yield$fetchAddOffers, statusCode;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            httpApi = _ref.httpApi, logger = _ref.logger;
            parameters = {
              offerIds: offerIds,
              dealType: mapDealType(dealType),
              offerType: mapOfferType(offerType),
              folderIds: folderIds
            };
            _context.prev = 2;
            _context.next = 5;
            return fetchAddOffersInFolders({
              httpApi: httpApi,
              parameters: parameters
            });
          case 5:
            _yield$fetchAddOffers = _context.sent;
            statusCode = _yield$fetchAddOffers.statusCode;
            if (!(statusCode === 200)) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", true);
          case 9:
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            logger.error(_context.t0, {
              description: 'Fail to add offers to folders'
            });
          case 14:
            return _context.abrupt("return", false);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};